import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AppContext from "../../AppContext";

import plusimgicon from "../../assets/media/icons/gallery.png";
import trahsicon from "../../assets/media/icons/trashRed.png";

import {
  BtnBold,
  BtnItalic,
  Editor,
  EditorProvider,
  Toolbar,
  BtnBulletList,
  BtnClearFormatting,
  BtnLink,
  BtnNumberedList,
  BtnRedo,
  BtnStrikeThrough,
  BtnStyles,
  BtnUnderline,
  BtnUndo,
  HtmlButton,
  Separator,
} from "react-simple-wysiwyg";

function NewsPage() {
  const buttonRef = useRef();
  const inputRef = useRef();
  const context = useContext(AppContext);
  const [images, setImages] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {}, []);

  const onFileChange = (e) => {
    let list = selectedFiles;
    for (let i = 0; i < e.target.files.length; i++) {
      list.push(e.target.files[i]);
    }
    setImages(list.map((file) => ({ url: URL.createObjectURL(file), name: file.name })));
    setSelectedFiles(list);
  };

  const renderPhotos = (source) => {
    return source.map((photo) => {
      return (
        <div className="photos" key={photo.url}>
          <img src={photo.url} className="photos-content" />
          <button className="trashbutton" color="elegant" onClick={() => onResetPhotos(photo.name)}>
            <img src={trahsicon} style={{ width: "60%" }} className="py-1" />
          </button>
        </div>
      );
    });
  };

  const onResetPhotos = (photo) => {
    var photos = [];
    for (let j = 0; j < selectedFiles.length; j++) {
      if (selectedFiles[j].name !== photo) {
        photos.push(selectedFiles[j]);
      }
    }
    setImages(photos.map((file) => ({ url: URL.createObjectURL(file), name: file.name })));
    setSelectedFiles(photos);
  };

  const handleChoose = (event) => {
    event.preventDefault();
    inputRef.current.click();
  };

  const handleSaveImage = (e) => {
    e.preventDefault();
    if (selectedFiles.length > 0) {
      let prom = [];
      let array = selectedFiles;
      for (let i = 0; i < selectedFiles.length; i++) {
        const formData = new FormData();
        formData.append("file", selectedFiles[i]);
        prom.push(
          context.interAxios.post(
            "/media",
            formData,
            { headers: { "Content-Type": "multipart/form-data" } },
            function (response) {
              array[i] = response.data.id;
            },
          ),
        );
      }
      Promise.all(prom).then(() => {
        onSaveProduct(array);
      });
    } else {
      alert("Tölts fel egy képet!");
    }
  };

  const onSaveProduct = (idsArray) => {
    var product = {
      title: title,
      description: description,
      imageId: idsArray[0],
    };

    context.interAxios.put("/news", product, function (response) {
      //navigate("/admin/productlist");
    });
  };

  return (
    <div className="addbike-container">
      <form onSubmit={(e) => handleSaveImage(e)} className="profile-form" autoComplete="off">
        <div className="add-image">
          <p className="add-image-title">Kép feltöltése*:</p>
          <div className="images-list">
            {renderPhotos(images)}
            {images.length === 0 && (
              <div className="add-image-div">
                <img
                  src={plusimgicon}
                  style={{ width: "80%", paddingTop: "0.8rem" }}
                  onClick={(e) => handleChoose(e)}
                />
                <input
                  ref={inputRef}
                  className="FileInput_input"
                  type="file"
                  accept=".jpg,.jpeg,.png"
                  onChange={onFileChange}
                />
              </div>
            )}
          </div>
        </div>
        <div className="input-div">
          <label htmlFor="title">Cím*</label>
          <input
            id="title"
            name="title"
            type="text"
            onChange={(event) => {
              setTitle(event.target.value);
            }}
            value={title}
            required
          />
        </div>

        <div className="input-div">
          <label htmlFor="description">Tartalom*</label>
          <EditorProvider>
            <Editor
              onChange={(event) => {
                setDescription(event.target.value);
              }}
              value={description}
              required
              containerProps={{ style: { resize: "vertical" } }}
            >
              <Toolbar>
                <BtnUndo />
                <BtnRedo />
                <Separator />
                <BtnBold />
                <BtnItalic />
                <BtnUnderline />
                <BtnStrikeThrough />
                <Separator />
                <BtnNumberedList />
                <BtnBulletList />
                <Separator />
                <BtnLink />
                <BtnClearFormatting />
                <HtmlButton />
                <Separator />
                <BtnStyles />
              </Toolbar>
            </Editor>
          </EditorProvider>
        </div>

        <div className="d-flex align-items-center justify-content-start py-4">
          <button type="submit" className="normal-button" ref={buttonRef}>
            <span>Mentés</span>
          </button>
        </div>
      </form>
    </div>
  );
}

export default NewsPage;
